/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Goals_Read_ListenInputs */

const en_onboarding_goals_read_listen = /** @type {(inputs: Onboarding_Goals_Read_ListenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read and listen at the same time`)
};

const es_onboarding_goals_read_listen = /** @type {(inputs: Onboarding_Goals_Read_ListenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer y escuchar al mismo tiempo`)
};

/**
* | output |
* | --- |
* | "Read and listen at the same time" |
*
* @param {Onboarding_Goals_Read_ListenInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_goals_read_listen = /** @type {((inputs?: Onboarding_Goals_Read_ListenInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Goals_Read_ListenInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_goals_read_listen(inputs)
	return en_onboarding_goals_read_listen(inputs)
});